/*
 * File: TakeAttendance.ts
 * Author: Austin Robinson
 * Date Created: 6/2/2023
 * Copyright (c) DrivingDoc 2023
 */
import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';
import { invalidateQueryKeys } from 'api/hooks/middlewares';

export type AttendanceValue = 'present' | 'absent' | 'no_permit' | null;

export interface TakeAttendanceParams {
  coursePeriodId: string;
  attendanceRecords: {
    studentId: string;
    attendance: 'present' | 'absent' | 'no_permit' | null;
  }[];
}

async function takeAttendance(params: TakeAttendanceParams | undefined): Promise<boolean> {
  if (params === undefined) {
    return false;
  }

  console.time('Take Attendance');
  // make api call
  await privateApi.post(`${import.meta.env.VITE_API_BASE_URL}/courses/takeAttendance`, params, {
    // headers: {
    // }
  });

  // return the data object
  return true;
}

const useTakeAttendance = createMutation<boolean, TakeAttendanceParams, AxiosError<ErrorResponse>>({
  mutationFn: async (variables: TakeAttendanceParams) => takeAttendance(variables),
  use: [
    invalidateQueryKeys<boolean, TakeAttendanceParams>((_data, variables) => {
      // Invalidate the specific course period
      const invalidations = [
        { queryKey: ['course_period', { id: variables.coursePeriodId }] },
        { queryKey: ['course_periods'] },
      ];

      // Invalidate student-specific queries for each affected student
      variables.attendanceRecords.forEach((record) => {
        invalidations.push(
          { queryKey: ['student_course_periods', { id: record.studentId }] },
          { queryKey: ['student_course_enrollments', { id: record.studentId }] },
          { queryKey: ['student_ledger', { id: record.studentId }] },
        );
      });

      return invalidations;
    }),
  ],
});

export { takeAttendance, useTakeAttendance };
